import _slicedToArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/regenerator/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useReducer, useState } from 'react';
import { NetworkContext } from './context';
import { defaultNetworkState, networksReducer } from './reducer';
import { Web3Provider, Provider } from '@ethersproject/providers';
import { subscribeToProviderEvents, getInjectedProvider } from '../../../helpers';
import { useConfig } from '../../config';
import { useLocalStorage } from '../../../hooks';
import detectEthereumProvider from '@metamask/detect-provider';

function tryToGetAccount(_x) {
  return _tryToGetAccount.apply(this, arguments);
}
/**
 * @internal Intended for internal use - use it on your own risk
 */


function _tryToGetAccount() {
  _tryToGetAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(provider) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return provider.getSigner().getAddress();

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);

            if (!(_context4.t0.code === 'UNSUPPORTED_OPERATION')) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", undefined);

          case 10:
            throw _context4.t0;

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 6]]);
  }));
  return _tryToGetAccount.apply(this, arguments);
}

export function NetworkProvider(_ref) {
  var children = _ref.children,
      providerOverride = _ref.providerOverride;

  var _useConfig = useConfig(),
      autoConnect = _useConfig.autoConnect,
      pollingInterval = _useConfig.pollingInterval;

  var _useReducer = useReducer(networksReducer, defaultNetworkState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      network = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState = useState(function () {
    return function () {
      return undefined;
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      onUnsubscribe = _useState2[0],
      setOnUnsubscribe = _useState2[1];

  var _useLocalStorage = useLocalStorage('shouldConnectMetamask'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      shouldConnectMetamask = _useLocalStorage2[0],
      setShouldConnectMetamask = _useLocalStorage2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var activateBrowserWallet = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var injectedProvider;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return getInjectedProvider(pollingInterval);

          case 3:
            injectedProvider = _context.sent;

            if (injectedProvider) {
              _context.next = 8;
              break;
            }

            reportError(new Error('No injected provider available'));
            setLoading(false);
            return _context.abrupt("return");

          case 8:
            _context.prev = 8;
            _context.next = 11;
            return injectedProvider.send('eth_requestAccounts', []);

          case 11:
            setShouldConnectMetamask(true);
            _context.next = 19;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](8);
            reportError(_context.t0);
            setShouldConnectMetamask(false);
            throw _context.t0;

          case 19:
            _context.prev = 19;
            setLoading(false);
            return _context.finish(19);

          case 22:
            return _context.abrupt("return", activate(injectedProvider));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 14, 19, 22]]);
  })), []);
  useEffect(function () {
    if (providerOverride) {
      activate(providerOverride);
    }
  }, [providerOverride]);
  var update = useCallback(function (newNetwork) {
    dispatch({
      type: 'UPDATE_NETWORK',
      network: newNetwork
    });
  }, [network]);
  var reportError = useCallback(function (error) {
    console.error(error);
    dispatch({
      type: 'ADD_ERROR',
      error: error
    });
  }, []);
  var deactivate = useCallback(function () {
    setShouldConnectMetamask(false);
    update({
      accounts: []
    });
  }, []);
  var onDisconnect = useCallback(function (error) {
    deactivate();
    reportError(error);
  }, []);
  useEffect(function () {
    setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _a, _b, _c;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!(shouldConnectMetamask && autoConnect && !providerOverride)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 4;
              return detectEthereumProvider();

            case 4:
              if (!(shouldConnectMetamask && ((_c = (_b = (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a._state) === null || _b === void 0 ? void 0 : _b.accounts) === null || _c === void 0 ? void 0 : _c.length) === 0)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return activateBrowserWallet();

            case 8:
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.warn(_context2.t0);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    })));
  }, [shouldConnectMetamask, autoConnect, providerOverride]);
  var activate = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(provider) {
      var _a, wrappedProvider, account, chainId, clearSubscriptions;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              wrappedProvider = Provider.isProvider(provider) ? provider : new Web3Provider(provider);
              _context3.prev = 1;
              setLoading(true);
              _context3.next = 5;
              return tryToGetAccount(wrappedProvider);

            case 5:
              account = _context3.sent;
              _context3.next = 8;
              return wrappedProvider.getNetwork();

            case 8:
              _context3.t1 = _a = _context3.sent;
              _context3.t0 = _context3.t1 === null;

              if (_context3.t0) {
                _context3.next = 12;
                break;
              }

              _context3.t0 = _a === void 0;

            case 12:
              if (!_context3.t0) {
                _context3.next = 16;
                break;
              }

              _context3.t2 = void 0;
              _context3.next = 17;
              break;

            case 16:
              _context3.t2 = _a.chainId;

            case 17:
              chainId = _context3.t2;
              onUnsubscribe();
              clearSubscriptions = subscribeToProviderEvents(wrappedProvider.provider, update, onDisconnect);
              setOnUnsubscribe(function () {
                return clearSubscriptions;
              });
              update({
                provider: wrappedProvider,
                chainId: chainId,
                accounts: account ? [account] : []
              });
              _context3.next = 28;
              break;

            case 24:
              _context3.prev = 24;
              _context3.t3 = _context3["catch"](1);
              reportError(_context3.t3);
              throw _context3.t3;

            case 28:
              _context3.prev = 28;
              setLoading(false);
              return _context3.finish(28);

            case 31:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 24, 28, 31]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [onUnsubscribe]);
  return _jsx(NetworkContext.Provider, {
    value: {
      network: network,
      update: update,
      activate: activate,
      deactivate: deactivate,
      reportError: reportError,
      activateBrowserWallet: activateBrowserWallet,
      isLoading: isLoading
    },
    children: children
  });
}